import React from 'react'
import { Typography, Modal, Button, Icon, Row, Col } from 'antd'
import ImageFile from '../ImageFile'

const { Text, Title } = Typography
class ModalImage extends React.PureComponent {

	async componentDidMount() {
    }

	render() {
		const { fileImg, hideModalImage, typeFile, file } = this.props
		return (
			<>
				<Modal
					className="modalImage"
					visible={true}
                    footer={[]}
					onOk={
						() =>{
							hideModalImage();
						}
					}
					onCancel={
						() =>{
							console.log('test')
							hideModalImage();
						}
					}
					width={1000}
					footer={null}>
						<>
							<Row className="py-3">
								<Col>
                                    {/* <img style={{ width: '100%' }} src={fileImg}></img> */}
									
                                    {/* //pendtest */}
                                    <ImageFile typeFile={typeFile}  file={file}/>
                                </Col>
							</Row>
						</>
				</Modal>
			</>
		)
	}
}

export default ModalImage